import { computed } from 'vue'
import { freezeObject } from '@/global/utils/utils'
import TabActionButtons from '@/global/components/view-layouts/tabs-layout/components/TabActionButtons.vue'
import IrregularityDetailsInfo from '@/modules/road-maintenance-module/winter-service-v2/irregularities/components/IrregularityDetailsInfo.vue'
import { useIrregularityFields } from '@/modules/road-maintenance-module/winter-service-v2/irregularities/composables/useIrregularityFields'
import { applyIrregularityForm } from '@/modules/road-maintenance-module/winter-service-v2/irregularities/composables/irregularityData'
import { WINTER_SERVICE_MODULE } from '@/modules/road-maintenance-module/winter-service-v2/common/config/constants'
import {
  IRREGULARITIES_ENDPOINT,
  IRREGULARITIES_INDEX_ROUTE,
  IRREGULARITIES_TRANSLATION_NAMESPACE as NS
} from '@/modules/road-maintenance-module/winter-service-v2/irregularities/config/constants'

const TAB_KEY = 'irregularity_details'

export function useIrregularityDetails (options) {
  const { translate, resolveRouteParamValue } = options || {}

  const { fields } = useIrregularityFields({ translate })

  // Read-only screen: the backend exposes the report through `index` and `show` and
  // nothing else, so there is no `post` here and no save to reach it.
  const apiConfig = freezeObject({
    get: {
      module: WINTER_SERVICE_MODULE,
      route: `${IRREGULARITIES_ENDPOINT}/${resolveRouteParamValue('id')}`
    }
  })

  // No edit buttons and no additional ones either - going back is the only action.
  const tabActions = computed(() => ({
    component: TabActionButtons,
    title: translate(`${NS}.irregularity_details`),
    showEditButtons: false,
    showBackButton: {
      uiViewName: IRREGULARITIES_INDEX_ROUTE
    },
    visible: true
  }))

  const infoBlock = computed(() => ({
    component: IrregularityDetailsInfo,
    visible: true,
    rows: [
      {
        type: 'fields',
        columnsCount: 1,
        fields: fields.value
      }
    ]
  }))

  // The backend reports an irregularity nested (the type, vehicle, driver and task
  // each their own object, the coordinates on `geolocation`); the fields read it flat.
  const onDataReceived = (apiData) => {
    applyIrregularityForm(apiData?.data)
  }

  return computed(() => ({
    key: TAB_KEY,
    apiConfig,
    onDataReceived,
    tabContent: [
      tabActions.value,
      infoBlock.value
    ]
  }))
}
